var exports = {
  "kL": "x43aef4ae--dcfba0--container",
  "Qs": "x43aef4ae--dcfba0--content",
  "h_": "x43aef4ae--dcfba0--description",
  "qG": "x43aef4ae--dcfba0--fadeIn",
  "iq": "x43aef4ae--dcfba0--image-container",
  "Sl": "x43aef4ae--dcfba0--image",
  "DD": "x43aef4ae--dcfba0--title",
  "Xn": "x43aef4ae--dcfba0--fadeOut",
};

module.exports = exports;
